module.exports = __webpack_public_path__ + "static/media/8.9fe6aa9c.jpeg";